import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	getCheckbookDetailDeposit,
	type IGetCheckbookDetailDepositParams,
	type ICheckbookDetailDeposit,
} from 'api/resources/generalLedgerTransactions';
import { ECacheKeys } from 'cache/CacheKeys';

export const useGetCheckbookDetailDeposit = (
	params: IGetCheckbookDetailDepositParams,
	options?: UseQueryOptions<ICheckbookDetailDeposit[]>
) => {
	const query = useQuery({
		queryKey: [
			ECacheKeys.GeneralLedgerTransactions,
			'CheckbookDetailDeposit',
			params.account,
			params.userdate,
			params.depositslip,
		],
		queryFn: () => getCheckbookDetailDeposit(params),
		refetchInterval: false,
		refetchOnWindowFocus: false,
		...(options || {}),
	});

	return query;
};
